import { bus } from "@/main";

export default {
	name: "HeaderBlock",
	data() {
		return {
			headerOpen: false,
			language: this.$route.params.lang
		}
	},
	props: [
		"black"
	],
	created() {},
	watch: {
		"$route": function () {
			this.language = this.$route.params.lang
		}
	},
	methods: {}
}



// WEBPACK FOOTER //
// ./src/components/blocks/header/header.block.js